import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Transition } from 'react-transition-group';
import { Animation, AnimationFixed } from '../animation/Animation';
import { ModalBackdrop, ModalComponent, ModalDialog, ModalContent, ModalHeader, Heading, SubTitle, CustomButton, ModalBody, ModalFooter, } from './mixins';
export const Modal = ({ animation, title, titleLevel, subtitle, footer, children, visible, onClose, width, skin, }) => {
    const modalDOM = document.getElementById('modal');
    useEffect(() => {
        if (visible) {
            document.body.style.height = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.height = 'auto';
            document.body.style.overflow = 'auto';
        };
    }, [visible]);
    if (!visible) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(Transition, { in: visible, timeout: 350, mountOnEnter: true }, (state) => (
    // state change: exited -> entering -> entered -> exiting -> exited
    React.createElement(React.Fragment, null,
        React.createElement(AnimationFixed, { name: animation, className: `animation-${state}` },
            React.createElement(ModalComponent, null,
                React.createElement(ModalDialog, { width: width },
                    React.createElement(ModalContent, null,
                        React.createElement(ModalHeader, { skin: skin },
                            React.createElement(Heading, { level: titleLevel || 3, skin: skin }, title),
                            subtitle && React.createElement(SubTitle, { skin: skin }, subtitle),
                            React.createElement(CustomButton, { buttonoptions: { variant: 'black', type: 'link' }, onClick: onClose, icon: { name: 'icon-light-close' } })),
                        React.createElement(ModalBody, { skin: skin }, children && children),
                        React.createElement(ModalFooter, { skin: skin }, footer && footer))))),
        React.createElement(Animation, { name: "fadeIn", className: `animation-${state}` },
            React.createElement(ModalBackdrop, { onClick: onClose }))))), modalDOM);
};
export default Modal;
